var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ArrowNarrowDownSvg from './arrow-narrow-down.icon.svg';
export const ArrowNarrowDownIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: ArrowNarrowDownSvg }));
_react_refresh_temp_1 = ArrowNarrowDownIcon;
$RefreshReg$(_react_refresh_temp_1, "ArrowNarrowDownIcon");
